export const GOAL_ORDER_SPACING = 10000